// The kinds the share dialog can share, and the collaboration v1 sharing
// policy for them (src/company-workspace/sharing/contract.mjs; docs/
// company-workspace.md § Sharing policy). The server decides; the UI uses these
// only to choose its words and to show Make private. No imports, so
// test/sharing-policy-kinds-unit.mjs holds these sets equal to the server's for
// every kind listed here.
export const SHARE_KINDS = ['file', 'skill', 'result', 'chat', 'project'] as const;
export type ShareKind = (typeof SHARE_KINDS)[number];
import { sharingCopyFor } from './sharing-copy.ts';

/** A member shares these with the whole company at once. */
export const INSTANT_COMPANY_KINDS: ReadonlySet<ShareKind> = new Set<ShareKind>([
  'chat',
  'result',
  'file',
  // Projects v1: sharing a project grants nothing, so it applies at once.
  'project',
]);
/** A company admin may make these private. */
export const ADMIN_PRIVATE_KINDS: ReadonlySet<ShareKind> = new Set<ShareKind>([
  'chat',
  'result',
  'file',
  'project',
]);

export function companyShareNotice(
  kind: ShareKind,
  canPublish: boolean,
  companyName: string,
  locale?: string,
) {
  const copy = sharingCopyFor(locale);
  if (canPublish) return copy.companyPublish;
  if (!INSTANT_COMPANY_KINDS.has(kind)) return copy.companyApproval;
  return copy.companyInstant.replace('{company}', companyName);
}
